import { ExecutiveCommandViewModel } from "./ExecutiveCommandView.model";

export class ExecutiveCommandView extends ExecutiveCommandViewModel {
    // Add custom methods here
}
